//文章
const articleBox          = () => import('@/components/article/articleBox');
const articleList         = () => import('@/components/article/articleList');
const addArticle          = () => import('@/components/article/article/addArticle');
const editArticle         = () => import('@/components/article/article/editArticle');
const articleInfo         = () => import('@/components/article/articleInfo');
const previewArticle      = () => import('@/components/article/previewArticle');

const editArticleContent  = () => import('@/components/article/article/editArticleContent');

const articleCategory     = () => import('@/components/article/category/articleCategory');



export default{
    path: '/articleBox',
    name: 'articleBox',
    component: articleBox,
    children: [
        { path: 'articleList', component: articleList, name: 'articleList' },
        { path: 'addArticle', component: addArticle, name: 'addArticle' },
        { path: 'editArticle', component: editArticle, name: 'editArticle' },
        { path: 'articleInfo', component: articleInfo, name: 'articleInfo' },
        { path: 'previewArticle', component: previewArticle, name: 'previewArticle' },
        { path: 'editArticleContent', component: editArticleContent, name: 'editArticleContent' },      
        { path: 'articleCategory', component: articleCategory, name: 'articleCategory' },        
    ]
}



// WEBPACK FOOTER //
// ./src/router/routes/article.js